// eslint-disable-next-line no-sparse-arrays
export var is=function is(type,val){return![,null].includes(val)&&val.constructor===type;};export default is;